import { render, staticRenderFns } from "./FullscreenMdEditor.vue?vue&type=template&id=3a16627d"
import script from "./FullscreenMdEditor.vue?vue&type=script&lang=js"
export * from "./FullscreenMdEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a16627d')) {
      api.createRecord('3a16627d', component.options)
    } else {
      api.reload('3a16627d', component.options)
    }
    module.hot.accept("./FullscreenMdEditor.vue?vue&type=template&id=3a16627d", function () {
      api.rerender('3a16627d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fullscreen-md-editor/FullscreenMdEditor.vue"
export default component.exports